import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";

export type RelatedProductDTO = Pick<
  ProductDataDTO,
  | "code"
  | "designation"
  | "sapMaterialNumber"
  | "url"
  | "preferred"
  | "shortDescription"
  | "manufacturerLogoUrl"
  | "images"
  | "showPostCartModal"
  | "quantityVisible"
  | "productAllCategories"
  | "fifteenDigit"
  | "salesCampaigns"
  | "stockAmount"
> & {
  allAliases: string[] | null;
};

export interface RelatedProductListResponseDTO {
  items?: RelatedProductDTO[];
}

export function toProductDataDTO({ allAliases, ...product }: RelatedProductDTO): ProductDataDTO {
  // The related-product endpoint deliberately returns a product-card subset.
  // transformProduct tolerates that subset; keep the assertion at this explicit boundary.
  return { ...product, aliases: allAliases } as ProductDataDTO;
}
